import React, { useEffect } from 'react';
import Container from '@/components/container';
import ContextProviderMenus from '@/components/slide-menu/provide-slide-menu';
import Tab from '@/components/slide-menu/tab-nav';
import { updateCrumbs } from '@/components/bread-crumbs';
import { getQuery } from '@/common/utils';

function Avenue(props) {
  useEffect(() => {
    let data;
    // ...通过请求获取到了数据...
    data = { planCode: getQuery('planCode') };

    // 离开当前页面清除面包屑的数据
    return updateCrumbs(data);
  });

  return (
    <>
      <Container padding={{ vertical: 'max', horizontal: 'max' }} margin={false}>
        <ContextProviderMenus.Provider value={{ children: props.children }}>
          <Tab />
        </ContextProviderMenus.Provider>
        <ContextProviderMenus.Provider>{props.children}</ContextProviderMenus.Provider>
      </Container>
    </>
  );
}

export default Avenue;
